// extracted by mini-css-extract-plugin
module.exports = {"auth-page":"Login_auth-page__1_OOs","auth-footer":"Login_auth-footer__2aI1V","btn-container":"Login_btn-container__2wA4-"};